import { render, staticRenderFns } from "./PurchaseItems.vue?vue&type=template&id=5033c596&"
import script from "./PurchaseItems.vue?vue&type=script&lang=js&"
export * from "./PurchaseItems.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports